import { makeObservable, observable } from 'mobx';

import { Model } from '../Model';

export interface ISpaceOwnerModel {
    id?: number;
    userId?: number;
    spaceId?: number;
}

export class SpaceOwnerModel extends Model implements ISpaceOwnerModel {
    id = 0;
    userId = 0;
    spaceId = 0;

    constructor(payload: ISpaceOwnerModel = {}) {
        super();

        makeObservable(this, {
            id: observable,
            userId: observable,
            spaceId: observable,
        });

        this.update(payload);
    }
}
